import { render } from "./Paragraph.vue?vue&type=template&id=2c97d00a&scoped=true"
import script from "./Paragraph.vue?vue&type=script&lang=js"
export * from "./Paragraph.vue?vue&type=script&lang=js"

import "./Paragraph.vue?vue&type=style&index=0&id=2c97d00a&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c97d00a"]])

export default __exports__